var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H22V22H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8.70833C22 5.41764 19.3324 2.75 16.0417 2.75C12.751 2.75 10.0833 5.41764 10.0833 8.70833C10.0833 11.999 12.751 14.6667 16.0417 14.6667C16.2207 14.6667 16.3979 14.6588 16.5729 14.6433L17.6309 17.1358C17.9276 17.8348 18.7348 18.1609 19.4338 17.8642C20.1328 17.5675 20.459 16.7603 20.1623 16.0612L19.189 13.7685C20.8768 12.7165 22 10.8436 22 8.70833ZM11.9167 8.70833C11.9167 6.43016 13.7635 4.58333 16.0417 4.58333C18.3198 4.58333 20.1667 6.43016 20.1667 8.70833C20.1667 10.9865 18.3198 12.8333 16.0417 12.8333C13.7635 12.8333 11.9167 10.9865 11.9167 8.70833ZM1.375 4.58333C0.615609 4.58333 0 5.19894 0 5.95833C0 6.71773 0.615609 7.33333 1.375 7.33333H6.875C7.63439 7.33333 8.25 6.71773 8.25 5.95833C8.25 5.19894 7.63439 4.58333 6.875 4.58333H1.375ZM0 11.4583C0 10.6989 0.615609 10.0833 1.375 10.0833H6.875C7.63439 10.0833 8.25 10.6989 8.25 11.4583C8.25 12.2177 7.63439 12.8333 6.875 12.8333H1.375C0.615609 12.8333 0 12.2177 0 11.4583ZM1.375 15.5833C0.615609 15.5833 0 16.1989 0 16.9583C0 17.7177 0.615607 18.3333 1.375 18.3333H11.4583C12.2177 18.3333 12.8333 17.7177 12.8333 16.9583C12.8333 16.1989 12.2177 15.5833 11.4583 15.5833H1.375Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.16692060c3a404b9b6b88396784b4211.svg";
export { ForwardRef as ReactComponent };